<template>
    <div class="inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1" :class="variantClasses">
        <span class="flex-shrink-0">
            <slot name="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" /><path d="M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2" /></svg>
            </slot>
        </span>

        <span class="text-xs font-medium">{{ label }}</span>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    label: {
        type: String,
        required: true
    },
    variant: {
        type: String,
        default: 'blue',
        validator: (value) => ['blue', 'purple', 'indigo', 'teal', 'orange', 'pink', 'gray'].includes(value)
    }
})

const variantClasses = computed(() => {
    const variants = {
        blue: 'border-blue-700/20 bg-blue-50 text-blue-700',
        purple: 'border-purple-700/20 bg-purple-50 text-purple-700',
        indigo: 'border-indigo-700/20 bg-indigo-50 text-indigo-700',
        teal: 'border-teal-700/20 bg-teal-50 text-teal-700',
        orange: 'border-orange-700/20 bg-orange-50 text-orange-700',
        pink: 'border-pink-700/20 bg-pink-50 text-pink-700',
        gray: 'border-gray-700/20 bg-gray-50 text-gray-700'
    }

    return variants[props.variant] || variants.blue
})
</script>